import {
  SafeAreaView,
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Image,
  ScrollView,
  Dimensions,
  FlatList,
  TextInput,
} from "react-native";
import React, { useState } from "react";
import AppFonts from "../../../Constants/AppFonts";
import AppImages from "../../../Constants/AppImages";
import AppColors from "../../../Constants/AppColors";

// import MapView, { Circle, Marker, PROVIDER_GOOGLE } from "react-native-maps";
import { createMaterialTopTabNavigator } from "@react-navigation/material-top-tabs";
import { GeoArea, MainPOint, ParkstationAll } from "../../../Constants/Data";
import Appstyles from "../../../Constants/AppStyles";

const { width, height } = Dimensions.get("window");
const Tab = createMaterialTopTabNavigator();
const GeofenceArea = ({ navigation }) => {
  const [selectedBox, setSelectedBox] = useState(1);
  const handleBoxPressbtn = (item) => {
    setSelectedBox(item);
  };

  const [DotModal, setDotModal] = React.useState(false);
  const [Modalvisible1, setModalvisible1] = React.useState(false);
  const [selectedItem, setSelectedItem] = React.useState(null);

  const [searchText, setSearchText] = React.useState("");

  //------Map-----------//
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [markerLocations, setMarkerLocations] = useState([]);

  const handleMapPress = (event) => {
    const { coordinate } = event.nativeEvent;
    setSelectedLocation(coordinate);
    setMarkerLocations([...markerLocations, coordinate]);
  };
  return (
    <SafeAreaView style={Appstyles.safe7}>
      <View style={Appstyles.HeaderMain}>
        <View style={Appstyles.HeaderSec}>
          <TouchableOpacity
            style={Appstyles.Arrowstyle}
            onPress={() => {
              if (typeof window !== "undefined" && window.history.length > 1) {
                window.history.back();
              } else {
                window.location.href = "/";
              }
            }}
          >
            <Image
              source={AppImages.Backbtn}
              style={Appstyles.ArrowImage}
              resizeMode="contain"
            />
          </TouchableOpacity>
          <Text style={Appstyles.HeaderText}>Geofence Area</Text>
        </View>
        <View style={Appstyles.rc}>
          <TouchableOpacity onPress={() => navigation.navigate("/Dashboard/DashboardMap/Alerts/View")}>
            <Image
              source={AppImages.Bellnoti}
              style={Appstyles.BellImage}
              resizeMode="contain"
            />
          </TouchableOpacity>
          <TouchableOpacity onPress={() => navigation.navigate("SelectedGeo")}>
            <Image
              source={AppImages.Plus}
              style={Appstyles.PlusImage}
              resizeMode="contain"
            />
          </TouchableOpacity>
        </View>
      </View>

      <View style={{ backgroundColor: AppColors.sandal, flex: 1 }}>
        <View style={{ backgroundColor: AppColors.white, flex: 1 }}>
          <View style={styles.hjhah}>
            {/* <View style={styles.mam}>
              <View style={styles.hjnshj}></View>
              <MapView
                style={styles.fleee}
                provider={PROVIDER_GOOGLE}
                showsUserLocation
                initialRegion={{
                  latitude: 37.78825,
                  longitude: -122.4324,
                  latitudeDelta: 0.0922,
                  longitudeDelta: 0.0421,
                }}
                onPress={handleMapPress}
              >
                {selectedLocation && (
                  <Circle
                    center={selectedLocation}
                    radius={3000} // Specify the radius of the circle in meters
                    strokeColor="rgba(66, 31, 0, 0.3)" // Set the stroke color and opacity
                    fillColor="rgba(66, 31, 0, 0.3)" // Set the fill color and opacity
                  />
                )}
              </MapView>
            </View> */}
          </View>
          <View style={Appstyles.viewofview7}>
            <View style={Appstyles.Searchvi6}>
              <TextInput
                style={Appstyles.TextInputr7}
                placeholder="Search Station Name, code, Address..."
                placeholderTextColor={"#AAAAAA"}
                editable={true}
                // value={searchText}

                autoCapitalize="none"
                // onChangeText={(text) => setsearchText(text)}
              />

              <View style={Appstyles.SearchImageView}>
                <Image
                  source={AppImages.search}
                  style={Appstyles.SearchImage}
                />
              </View>
            </View>

            <Image
              source={AppImages.Import}
              style={Appstyles.ImpoShare7}
              resizeMode="contain"
            />

            <Image
              source={AppImages.Shareit}
              style={Appstyles.ImpoShare7}
              resizeMode="contain"
            />
          </View>
          <ScrollView
            contentContainerStyle={{ flexGrow: 1 }}
            showsVerticalScrollIndicator={false}
          >
            <View style={{}}>
              <FlatList
                showsVerticalScrollIndicator={false}
                data={GeoArea}
                ListFooterComponent={() => <View style={{ padding: 0 }} />}
                renderItem={({ item }) => (
                  <TouchableOpacity
                    style={{
                      backgroundColor:
                        selectedItem === item
                          ? AppColors.sandal
                          : AppColors.white,
                      marginHorizontal: 20,
                      borderRadius: selectedItem === item ? 10 : 5,
                      borderWidth: selectedItem === item ? 0.5 : 0.5,
                      marginBottom: 20,
                      paddingVertical: 5,

                      borderColor:
                        selectedItem === item
                          ? AppColors.sandal
                          : AppColors.brown,
                    }}
                    onPress={() => setSelectedItem(item)}
                  >
                    <View
                      style={{
                        marginHorizontal: 20,
                        marginTop: 5,
                        marginBottom: 5,
                      }}
                    >
                      <View style={{ flexDirection: "row" }}>
                        <Text
                          style={{
                            width: "50%",
                            fontFamily: AppFonts.OverpassRegular,
                            fontSize: 12,
                            color: AppColors.dualbrown,
                          }}
                        >
                          Geofence Area
                        </Text>
                        <Text
                          style={{
                            fontFamily: AppFonts.OverpassRegular,
                            fontSize: 12,
                            color: AppColors.dualbrown,
                          }}
                        >
                          Address
                        </Text>
                      </View>

                      <View style={{}}>
                        <View style={{ flexDirection: "row" }}>
                          <Text
                            style={{
                              width: "50%",
                              fontFamily: AppFonts.OverpassSemiBold,
                              fontSize: 14,
                              color: AppColors.brown,
                            }}
                          >
                            {item.Plc}
                          </Text>
                          <Text
                            style={{
                              width: "50%",
                              fontFamily: AppFonts.OverpassSemiBold,
                              fontSize: 14,
                              color: AppColors.brown,
                            }}
                          >
                            {item.Test12345}
                          </Text>
                        </View>
                      </View>
                      <View style={{ flexDirection: "row", marginTop: 10 }}>
                        <Text
                          style={{
                            width: "50%",
                            fontFamily: AppFonts.OverpassRegular,
                            fontSize: 12,
                            color: AppColors.dualbrown,
                          }}
                        >
                          City
                        </Text>
                        <Text
                          style={{
                            fontFamily: AppFonts.OverpassRegular,
                            fontSize: 12,
                            color: AppColors.dualbrown,
                          }}
                        >
                          Country
                        </Text>
                      </View>

                      <View style={{}}>
                        <View style={{ flexDirection: "row" }}>
                          <Text
                            style={{
                              width: "50%",
                              fontFamily: AppFonts.OverpassSemiBold,
                              fontSize: 14,
                              color: AppColors.brown,
                            }}
                          >
                            {item.Citys}
                          </Text>
                          <Text
                            style={{
                              width: "50%",
                              fontFamily: AppFonts.OverpassSemiBold,
                              fontSize: 14,
                              color: AppColors.brown,
                            }}
                          >
                            {item.Country}
                          </Text>
                        </View>
                      </View>
                    </View>
                  </TouchableOpacity>
                )}
                keyExtractor={(item) => item.id.toString()} // Assuming each item has a unique id property
                extraData={selectedItem} // Update when the selectedItem changes
                // onPress={() => setSelectedItem(item)}
              />
            </View>
          </ScrollView>
        </View>
      </View>
    </SafeAreaView>
  );
};

export default GeofenceArea;

const styles = StyleSheet.create({
  LoginWithOtpVw: {
    borderColor: "#9C4900",
    borderWidth: 1,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 10,
    padding: 8,
    width: "100%",
    // height: 40,
  },
  RegisterTxt: {
    // color: AppColors.brown,
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 14,
    letterSpacing: 0.56,
  },
  RegisterNxt: {
    // color: AppColors.white,
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 14,
    letterSpacing: 0.56,
  },
  LoginWithOtpV: {
    borderColor: "#9C4900",
    borderWidth: 1,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 10,
    width: "100%",
    height: 40,
  },
  sty: {
    flexDirection: "row",
    marginVertical: 20,
  },
  hjhah: {
    height: height * 0.4,
  },
  mam: { flex: 1, position: "relative" },
  hjnshj: {
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "flex-end",
    paddingRight: 15,
    position: "absolute",
    bottom: 15,
    left: 0,
    right: 0,
    zIndex: 1,
  },
  fleee: { flex: 1 },
  ims: { width: 22, height: 22 },
  ha: { width: 22, height: 22 },

  feed: { backgroundColor: AppColors.ModalColor, flex: 1 },
  viww: {
    width: "100%",
    backgroundColor: "white",

    borderTopRightRadius: 16,
    borderTopLeftRadius: 16,
    position: "absolute",
    bottom: 0,
    padding: 20,
  },
  hsh: { justifyContent: "center", alignItems: "center" },
  jns: { width: "15%", height: 2 },
  yooo: {
    alignItems: "center",
    justifyContent: "center",
    marginLeft: 10,
  },
  ttxt: {
    fontFamily: AppFonts.OverpassRegular,

    fontSize: 14,
    color: AppColors.brown1,
  },
  fffsf: {
    marginTop: 20,
    flexDirection: "row",
  },
  modo: {
    fontFamily: AppFonts.OverpassRegular,

    fontSize: 16,
    color: AppColors.brown1,
  },
  presse: {
    flex: 1,
    backgroundColor: AppColors.BLUR_BG,
    alignItems: "center",
    justifyContent: "center",
  },
  dsdd: {
    backgroundColor: "white",
    borderRadius: 20,
    marginHorizontal: 20,
    width: "80%",
    paddingTop: 15,
  },
  sss: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginHorizontal: 20,
  },
  fd: { flexDirection: "row", alignItems: "center" },
  hbh: {
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 20,
    lineheight: 25.32,
    color: AppColors.brown1,
  },
  hhsj: { width: 24, height: 24 },
  fasfd: { marginTop: 20, marginHorizontal: 20 },
  sdsds: {
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 14,
    lineheight: 17.72,
    color: AppColors.brown1,
  },
  mmm: {
    flexDirection: "row",
    alignSelf: "flex-end",

    marginHorizontal: 20,
  },
  toda: { marginTop: 20, flexDirection: "row" },
});
